/**
 * Removes undefined values from an object and converts the remaining values to strings.
 *
 * This utility function takes an object and returns a new object with all the properties
 * that have defined values. The values are converted to strings.
 *
 * @template T - Type of the input object, extending Record<string, any>
 * @param {T} obj - The object to process
 * @returns {Record<string, string>} A new object with only defined values converted to strings
 *
 * @example
 * removeUndefinedQueryParams({ name: "John", age: 30, address: undefined });
 */
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
const removeUndefinedQueryParams = <T extends Record<string, any>>(
  obj: T,
): Record<string, string> => {
  const result: Record<string, string> = {};
  Object.entries(obj).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      result[key] = String(value);
    }
  });

  return result;
};

export default removeUndefinedQueryParams;
